"use strict";
import { UniverseChainId } from "uniswap/src/features/chains/types";
export var ExploreTab = /* @__PURE__ */ ((ExploreTab2) => {
  ExploreTab2["Tokens"] = "tokens";
  ExploreTab2["Pools"] = "pools";
  ExploreTab2["Transactions"] = "transactions";
  return ExploreTab2;
})(ExploreTab || {});
export const EXPLORE_CHAIN_SELECT_CHAIN_IDS = [
  UniverseChainId.Mainnet,
  UniverseChainId.Bnb,
  UniverseChainId.HyperMainnet
];
export const EXPLORE_DUNE_DASHBOARD_URLS = {
  [UniverseChainId.Bnb]: "https://dune.com/ring_protocol/ring-dashboard-bsc",
  [UniverseChainId.HyperMainnet]: "https://dune.com/ring_protocol/ring-dashboard-hyperevm"
};
